import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps, ConfigsProvider, PromiseLoader } from "react-builder";
import { PcPrivacyUserData, usePcPrivacyUseData } from "../../providers/PcPrivacyUserData";
import { useEffect, useState } from "react";

@AttributeGroup({ title: 'PcPrivacyProvider', blockName: 'PcPrivacyProvider', module: 'pcprivacy' })
export class PcPrivacyProviderAttributes extends Attribute {

}

function PcPrivacyProvider(props: ComponentProps<PcPrivacyProviderAttributes>) {

    const pcApi = usePcPrivacyUseData();
    const [pcUserDataPromise, setPcUserDataPromise] = useState<Promise<PcPrivacyUserData>>();

    useEffect(() => {
        setPcUserDataPromise(pcApi?.getData());
    }, [pcApi]);

    return (
        <PromiseLoader promise={pcUserDataPromise} loader={<></>} >
            {data =>
                <ConfigsProvider configJson={{ pcPrivacy: data }} >
                    <>
                        {props.children}
                    </>
                </ConfigsProvider>

            }
        </PromiseLoader>
    )
}


PcPrivacyProvider.prototype.Props = PcPrivacyProviderAttributes;


export default PcPrivacyProvider;